/*
 *
 * Settings actions
 *
 */

import {
  FLUSH_STATE_SETTINGS,
  LOAD_SETTINGS,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_ERROR,
  CHANGE_SETTINGS,
  CHANGE_SETTINGS_SUCCESS,
  CHANGE_SETTINGS_ERROR,
  DELETE_SETTINGS,
  DELETE_SETTINGS_SUCCESS,
  DELETE_SETTINGS_ERROR,
} from './constants';

/**
 * Clearing the state for Settings
 */
export function flushStateSettings() {
  return {
    type: FLUSH_STATE_SETTINGS,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Settings, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_SETTINGS
 */
export function loadSettings() {
  return {
    type: LOAD_SETTINGS,
  };
}

/**
 * Dispatched when the loadSettings are loaded by the request saga
 *
 * @param  {array} variables true for Settings
 *
 * @return {array} An action object with a type of LOAD_SETTINGS_SUCCESS passing the variables
 */
export function loadSettingsSuccess(settingsList) {
  return {
    type: LOAD_SETTINGS_SUCCESS,
    settingsList,
  };
}

/**
 * Dispatched when loading the loadSettings fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_SETTINGS_ERROR passing the error
 */
export function loadSettingsError(error) {
  return {
    type: LOAD_SETTINGS_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the Settings, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_SETTINGS
 */
export function changeSettings(settingsData) {
  return {
    type: CHANGE_SETTINGS,
    settingsData,
  };
}

/**
 * Dispatched when the changeSettings are changed/updated by the request saga
 *
 * @param  {array} variables true for Settings
 *
 * @return {array} An action object with a type of CHANGE_SETTINGS_SUCCESS passing the variables
 */
export function changeSettingsSuccess(settingsData) {
  return {
    type: CHANGE_SETTINGS_SUCCESS,
    settingsData,
  };
}

/**
 * Dispatched when loading the changeSettings fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_SETTINGS_ERROR passing the error
 */
export function changeSettingsError(error) {
  return {
    type: CHANGE_SETTINGS_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the Settings, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_SETTINGS
 */
export function deleteSettings(id) {
  return {
    type: DELETE_SETTINGS,
    id,
  };
}

/**
 * Dispatched when the deleteSettings are deleted by the request saga
 *
 * @param  {object} variables true for Settings
 *
 * @return {object} An action object with a type of DELETE_SETTINGS_SUCCESS passing the variables
 */
export function deleteSettingsSuccess() {
  return {
    type: DELETE_SETTINGS_SUCCESS,
  };
}

/**
 * Dispatched when loading the deleteSettings fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_SETTINGS_ERROR passing the error
 */
export function deleteSettingsError(error) {
  return {
    type: DELETE_SETTINGS_ERROR,
    error,
  };
}
